import * as React from "react";

export const LevelEight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <circle cx={22} cy={22} r={22} fill="#169FED" />
    <path
      stroke="#fff"
      strokeWidth={2.089}
      d="M30.983 31.666H12.88V23.31h18.103v8.356Zm0-19.482v8.356H12.88v-8.355h18.103Z"
    />
  </svg>
);
